"use client" // Error components must be Client Components

import { useEffect } from "react"
import { HeroText } from "src/components/generic/HeroText"

export type ErrorBoundaryFallbackProps = {
  error: Error & { digest?: string }
  reset?: () => void
}

/**
 * See https://nextjs.org/docs/app/building-your-application/routing/error-handling
 */
export function ErrorBoundaryFallback({ error }: ErrorBoundaryFallbackProps) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return <HeroText heading="Fehler" description="Es tut uns leid, ein Fehler ist aufgetreten." />
}
